import { Badge } from '../../../shared/components';
import { TurnoGeoRecord } from '../../../shared/services/turnoGeo/types';

/** Sí / No según la re-evaluación en vivo con las sedes y ubicaciones vigentes, con el motivo debajo. */
export function CumpleCell({ r }: { r: TurnoGeoRecord }) {
  const v = r.revalidation;
  if (!v) return <span className="text-ink-300">—</span>;
  return (
    <div className="max-w-[220px]">
      <Badge tone={v.cumple ? 'success' : 'warning'}>{v.cumple ? 'Sí' : 'No'}</Badge>
      <p className="mt-0.5 text-[11px] leading-snug text-ink-500">{v.motivo}</p>
      {v.changed && <p className="mt-0.5 text-[10px] text-ink-400">Hoy se valida como {v.modalityName} (al marcar quedó {r.modalityName}).</p>}
    </div>
  );
}

export function cumpleText(r: TurnoGeoRecord): string {
  return r.revalidation ? (r.revalidation.cumple ? 'Sí' : 'No') : '';
}
